var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.label)?_c('label',[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.currencyMask),expression:"currencyMask"}],staticClass:"form-control",attrs:{"disabled":_vm.disabled,"type":"text","placeholder":""},domProps:{"value":_vm.value},on:{"input":_vm.updateValue}})])
}
var staticRenderFns = []

export { render, staticRenderFns }